export class Contract {
    contractId: number = 0;
    contractNumber: string = '';
    contractType: string = '';
    locCode: string = '';
    contractDate: string = '';
    customerContract: string = '';
    shippingPeriod: number = 0;
    periodBeginDate: string = '';
    periodEndDate: string = '';
    quantity: string = '';
    openQuantity: string = '';
    loads: number = 0;
    loadsDisplay: string = '';
    openLoads: string = '';
    price: string = '';
    commodityCode: string = '';
    customerCode: string = '';
    customerName: string = '';
    locationCode: string = '';
    locationName: string = '';
    locationCity: string = '';
    deliveryTerm: string = '';
    termLocation: string = '';
    pricingZone: string = '';
}
